import { Click, ClickType, ElementType, Impression } from '@fiverr-private/bianka_js';
import { bianka } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { ComplianceBiEventsData } from '../types/upgradeModal';

export const reportUpsellModalImpression = ({ pageName, upgradeSource, sellerId }: ComplianceBiEventsData) => {
    const { pageCtxId, userId, organizationId } = getContext();

    bianka.reportActivity<Impression>({
        type: Impression,
        event: {
            type: 'viewed_pro_subscription_advanced_upsell',
            page: {
                name: pageName,
                ctxId: pageCtxId,
            },
            seller: {
                id: sellerId,
            },
            organization: {
                id: organizationId as string,
            },
            user: {
                id: userId as number,
            },
            component: {
                impId: Date.now().toString(),
                level: 1,
                isLeaf: false,
                positionInParent: 1,
                numberOfElements: 1,
                sizeInParent: 1,
                visibleThroughScroll: true,
                name: 'pro_subscription_advanced_upsell',
                text: upgradeSource,
            },
        },
    });
};

export const reportClickedProUpgradeBackButton = ({ pageName, upgradeSource, sellerId }: ComplianceBiEventsData) => {
    const { pageCtxId, userId, organizationId } = getContext();

    bianka.reportActivity<Click>({
        type: Click,
        page: {
            name: pageName,
            ctxId: pageCtxId,
        },
        event: {
            clickType: ClickType.LEFT,
            type: 'clicked_pro_subscription_advanced_plan_upgrade_back_button',
            user: {
                id: userId as number,
            },
            seller: {
                id: sellerId,
            },
            element: {
                name: 'pro_subscription_advanced_plan_upgrade_back_button',
                type: ElementType.BUTTON,
                text: { value: upgradeSource },
            },
            organization: {
                id: organizationId as string,
            },
        },
    });
};

export const reportClickedProSubscriptionAdvancedUpsell = ({
    pageName,
    upgradeSource,
    sellerId,
}: ComplianceBiEventsData) => {
    const { pageCtxId, userId, organizationId } = getContext();

    bianka.reportActivity<Click>({
        type: Click,
        page: {
            name: pageName,
            ctxId: pageCtxId,
        },
        event: {
            clickType: ClickType.LEFT,
            type: 'clicked_pro_subscription_advanced_upsell',
            user: {
                id: userId as number,
            },
            seller: {
                id: sellerId,
            },
            element: {
                name: 'pro_subscription_advanced_upsell',
                type: ElementType.BUTTON,
                text: { value: upgradeSource },
            },
            organization: {
                id: organizationId as string,
            },
        },
    });
};

export const reportWelcomeToAdvancedModalImpression = ({
    pageName,
    upgradeSource,
    sellerId,
}: ComplianceBiEventsData) => {
    const { pageCtxId, userId, organizationId } = getContext();

    bianka.reportActivity<Impression>({
        type: Impression,
        event: {
            type: 'viewed_pro_subscription_welcome_to_advanced_modal',
            page: {
                name: pageName,
                ctxId: pageCtxId,
            },
            seller: {
                id: sellerId,
            },
            organization: {
                id: organizationId as string,
            },
            user: {
                id: userId as number,
            },
            component: {
                impId: Date.now().toString(),
                level: 1,
                isLeaf: false,
                positionInParent: 1,
                numberOfElements: 1,
                sizeInParent: 1,
                visibleThroughScroll: true,
                name: 'pro_subscription_welcome_to_advanced_modal',
                text: upgradeSource,
            },
        },
    });
};

export const reportClickedWelcomeToAdvancedContinue = ({
    pageName,
    upgradeSource,
    sellerId,
}: ComplianceBiEventsData) => {
    const { pageCtxId, userId, organizationId } = getContext();

    bianka.reportActivity<Click>({
        type: Click,
        page: {
            name: pageName,
            ctxId: pageCtxId,
        },
        event: {
            clickType: ClickType.LEFT,
            type: 'clicked_pro_subscription_welcome_to_advanced_modal_continue',
            user: {
                id: userId as number,
            },
            seller: {
                id: sellerId,
            },
            element: {
                name: 'pro_subscription_welcome_to_advanced_modal_continue',
                type: ElementType.BUTTON,
                text: { value: upgradeSource },
            },
            organization: {
                id: organizationId as string,
            },
        },
    });
};

export const reportClickedExitWelcomeToAdvancedModal = ({
    pageName,
    upgradeSource,
    sellerId,
}: ComplianceBiEventsData) => {
    const { pageCtxId, userId, organizationId } = getContext();

    bianka.reportActivity<Click>({
        type: Click,
        page: {
            name: pageName,
            ctxId: pageCtxId,
        },
        event: {
            clickType: ClickType.LEFT,
            type: 'clicked_pro_subscription_welcome_to_advanced_modal_exit',
            user: {
                id: userId as number,
            },
            seller: {
                id: sellerId,
            },
            element: {
                name: 'pro_subscription_welcome_to_advanced_modal_exit',
                type: ElementType.BUTTON,
                text: { value: upgradeSource },
            },
            organization: {
                id: organizationId as string,
            },
        },
    });
};
